@import 'abstract/colors';

contact-livechat-login-popup a {
  color: $main;
}
